import { Flex, Tooltip } from '@chakra-ui/react';
import { GenericSubmissionField } from 'src/components/Submission/MySubmission/FormFieldGeneric/GenericSubmissionField';
import { useAssessmentData } from 'src/contexts/AssessmentDataProvider';
import AssessmentInvitation from '../../../../components/Assessment/Invitation';
import SubmissionFiles from '../../../../components/Assessment/SubmissionFiles';
import { Badge } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/pro-light-svg-icons';
import { faDiagramSubtask, faLanguage } from '@fortawesome/pro-regular-svg-icons';

export const SubmissionDetails = () => {
  const { fieldsResponse, earlyAssessment } = useAssessmentData();
  const { articleTypeName, fields } = fieldsResponse;
  const isInviteAccepted = earlyAssessment.workflow.currentState === 'invited';
  const articleSubType = fields['ArticleSubtype']?.value as string | undefined;
  const articleLanguage = fields['ArticleLanguage']?.value as string | undefined;


  return (
    <Flex flexDirection="column" gap={8} paddingX={12}>
      <Flex gap={4}>
        {articleTypeName && (
          <Badge variant="attention" size="context">
            <Flex gap={1} alignItems="center">
              <FontAwesomeIcon icon={faFileLines} />
              {articleTypeName}
            </Flex>
          </Badge>
        )}
         {articleSubType && (
          <Tooltip
            hasArrow
            placement="bottom"
            label={`Article Sub Type`}
            borderRadius={4}
            shouldWrapChildren
          >
            <Badge variant="interactive" size="context">
              <Flex gap={1} alignItems="center">
                <FontAwesomeIcon icon={faDiagramSubtask} />
                {articleSubType}
              </Flex>
            </Badge>
          </Tooltip>
        )}
        {articleLanguage && (
          <Tooltip
            hasArrow
            placement="bottom"
            label={`Article Language`}
            borderRadius={4}
            shouldWrapChildren
          >
            <Badge variant="success" size="context">
              <Flex gap={1} alignItems="center">
                <FontAwesomeIcon icon={faLanguage} />
                {articleLanguage}
              </Flex>
            </Badge>
          </Tooltip>
        )}
      </Flex>
      <GenericSubmissionField entryPoint="early-assessment" fieldName="Title" />
      <GenericSubmissionField entryPoint="early-assessment" fieldName="EnglishTitle" />
      <GenericSubmissionField entryPoint="early-assessment" fieldName="Subtitle" />
      <GenericSubmissionField entryPoint="early-assessment" fieldName="EnglishSubtitle" />

      {isInviteAccepted && <AssessmentInvitation />}
      <GenericSubmissionField entryPoint="early-assessment" fieldName="Abstract" />
      <GenericSubmissionField entryPoint="early-assessment" fieldName="EnglishAbstract" />
      <GenericSubmissionField entryPoint="early-assessment" fieldName="Keywords" />
      <GenericSubmissionField entryPoint="early-assessment" fieldName="SubmissionGuidelines" />
      <GenericSubmissionField entryPoint="early-assessment" fieldName="EnglishKeywords" />
      <GenericSubmissionField entryPoint="early-assessment" fieldName="ArticleSubtype" />
      <GenericSubmissionField entryPoint="early-assessment" fieldName="ArticleLanguage" />

      {fieldsResponse.fields['Supplementary']?.value ||
        fieldsResponse.fields['Manuscript']?.value ||
        fieldsResponse.fields['AnonymizedManuscript']?.value ||
        fieldsResponse.fields['Figures']?.value ||
        fieldsResponse.fields['Tables']?.value  ? (
        <SubmissionFiles entryPoint='early-assessment' />
      ) : null}
         <GenericSubmissionField
        entryPoint="early-assessment"
        fieldName="NumberOfFigures"
      />
      <GenericSubmissionField
        entryPoint="early-assessment"
        fieldName="NumberOfColorFigures"
      />
      <GenericSubmissionField
        entryPoint="early-assessment"
        fieldName="NumberOfTables"
      />
      <GenericSubmissionField
        entryPoint="early-assessment"
        fieldName="NumberOfWords"
      />
      <GenericSubmissionField
        entryPoint="early-assessment"
        fieldName="GeneralClassifications"
      />
    </Flex>
  );
};
